import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ui } from "../config/theme";
import { Clock, User } from "lucide-react";
import { API_BASE_URL } from "../config/apiconfig";


const ArticleDetails = () => {
    const { id } = useParams();
    const [article, setArticle] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchArticle = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/articles/${id}`);
                if (response.ok) {
                    const data = await response.json();
                    setArticle(data);
                } else {
                    console.error("Error fetching article:", response.statusText);
                }
            } catch (error) {
                console.error("Error fetching article:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchArticle();
    }, [id]);

    if (isLoading) {
        return (
            <div className={ui.page}>
                <Header />
                <main className="flex-grow">
                    <div className={ui.container}>
                        <div className={`${ui.sectionCard} p-8`}>
                            <div className="animate-pulse">
                                <div className="h-8 bg-gray-200 rounded w-3/4 mb-6"></div>
                                <div className="h-4 bg-gray-200 rounded w-full mb-4"></div>
                                <div className="h-4 bg-gray-200 rounded w-full mb-4"></div>
                                <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        );
    }

    if (!article) {
        return (
            <div className={ui.page}>
                <Header />
                <main className="flex-grow">
                    <div className={ui.container}>
                        <div className={`${ui.sectionCard} p-8 text-center`}>
                            <p className="text-gray-600">Article not found</p>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        );
    }

    return (
        <div className={ui.page}>
            <Header />
            <main className="flex-grow">
                <div className={ui.container}>
                    <div className={`${ui.sectionCard} p-8`}>
                        {/* Article Header */}
                        <h1 className="text-3xl font-bold text-gray-900 mb-4">
                            {article.title}
                        </h1>
                        
                        {/* Article Meta */}
                        <div className="flex items-center gap-6 text-sm text-gray-500 mb-8">
                            <div className="flex items-center gap-2">
                                <User className="w-4 h-4" />
                                <span>Admin</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <Clock className="w-4 h-4" />
                                <span>{new Date().toLocaleDateString()}</span>
                            </div>
                        </div>

                        {/* Article Description */}
                        <div className="text-lg text-gray-600 mb-8 leading-relaxed">
                            {article.description}
                        </div>

                        {/* Article Content */}
                        <div className="prose max-w-none">
                            <div className="text-gray-700 leading-relaxed space-y-6">
                                {article.content && typeof article.content === 'string' 
                                    ? article.content.split('\n').filter(Boolean).map((paragraph, index) => (
                                        <p key={index} className="mb-4">{paragraph}</p>
                                    ))
                                    : <p>{article.content}</p>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default ArticleDetails;